


































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import CourseSkill from "../api/courseSkill";
import {MediaFileField} from "@/models/fields";
import FieldImage from "@/components/FieldImage.vue";
import Hint from "@/api/hint";
import Media from "@/api/media";

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
        'field-image': FieldImage,
    },
})
export default class FieldCourseSkill extends CommonVue {
    @Model('update') public course_skill_list!: CourseSkill[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Number}) public moduleId!: number;

    public course_skill: CourseSkill = null;
    public isNewElement: boolean = false;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(course_skill: CourseSkill) {
        this.course_skill = course_skill;
        this.isNewElement = false;
        this.showModal = true;
    }

    public newCourseSkill() {
        this.course_skill = new CourseSkill();
        this.course_skill.parent_module = this.moduleId;
        this.isNewElement = true;
        this.showModal = true;
    }

    public async saveClicked() {
        if (!this.course_skill) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.course_skill.state === 'created') {
                this.course_skill_list.push(this.course_skill);
            }
            this.course_skill.state = "updated";
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save course skill', e);
        }
    }

    public static async saveCourseSkills(course_skills: CourseSkill[], parent_id: number) {
        for (const course_skill of course_skills) {
            if (course_skill.state === 'updated') {
                if (!course_skill.id) {
                    course_skill.parent_module = parent_id;
                }

                await FieldCourseSkill.saveCourseSkill(course_skill)

            } else if (course_skill.state === 'deleted' && course_skill.id) {
                await course_skill.delete();
            }
        }
    }

    public static async saveCourseSkill(course_skill: CourseSkill) {
        if (!course_skill.id) {
            course_skill.id = await course_skill.save();
        }
        await FieldCourseSkill.saveMediaFiles(course_skill);
        course_skill = new CourseSkill().assign(course_skill);
        await course_skill.save();
    }


    public static async saveMediaFiles(course_skill: CourseSkill) {
        if (course_skill.icon_file) {
            const icon = await Media.createImage(
                course_skill.icon_file,
                "courseskill",
                course_skill.id,
                'icon'
            );
            if (icon !== null) {
                course_skill.icon = icon;
            }
        } else if (course_skill.icon_file === null) {
            await Media.deleteImage(course_skill.icon);
            course_skill.icon = undefined;
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.course_skill.name) {
            throw Error('Please insert the name.');
        }
        if (!(this.$refs.icon_image as MediaFileField).hasMedia()) {
            throw Error('Please select an image file for this course skill.');
        }
        return;
    }

    public async deleteClicked() {
        const newList = this.course_skill_list.filter((value) => {
            return value !== this.course_skill;
        });
        this.course_skill.state = "deleted";
        this.$emit('update', newList);
        this.showModal = false;
    }

}

